const joinUsStatus = ['Pending', 'Approved', 'Rejected','Waiting'];
const userStatus = ['Pending', 'Active', 'Inactive'];

const allStatus = {
  joinUsStatus,
  userStatus,
};
export default allStatus;
